
export default function Cross() {
  return (
    <div>
      <svg width="80" height="80" viewBox="-50 -50 100 100" className="cross">
        <line x1="-40" y1="-40" x2="40" y2="40" />
        <line x1="-40" y1="40" x2="40" y2="-40" />
      </svg>
    </div>
  )
}